
export const firstLetterCapital = value => {
    const format = value.charAt(0).toUpperCase() + value.slice(1)
    return format
  }